// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementContentBlocksTagsResult = objectOf({
  all_tags: arrayOf(string),
  used_tags: arrayOf(string),
});
